import type * as React from 'react';
import { post } from '@Domain/Api';
import type { UserPayload } from '@Application/Users/Users/Actions/usersFetched';
import userInvited, { type UserInvitedAction } from '@Application/Users/Users/Actions/userInvited';
import userInvitationFailed, {
	type UserInvitationFailedAction,
} from '@Application/Users/Users/Actions/userInvitationFailed';
import type InviteUser from '@Application/Users/Users/Commands/InviteUser';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = UserInvitedAction | UserInvitationFailedAction;

export default (command: InviteUser) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<UserPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/users`,
				command.toJSON(),
			);

			const action = userInvited(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = userInvitationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
